module.exports = __webpack_public_path__ + "static/media/play-store.0e12fb44.svg";